import { api, headers } from "./api";

const RESOURCE = 'lembaga';

export const indexLembaga = ()=> api.get(RESOURCE, headers);

export const storeLembaga = (data) => api.post(RESOURCE, data, headers);
